import { SnapshotIn, types as t } from 'mobx-state-tree';
import { ScriptCaption } from './script-caption.store';
import { AbstractScript } from '../abtract-script.store';

export const MonologScript = AbstractScript.named('MonologScript').props({
  subtitle: t.optional(t.array(ScriptCaption), []),
});

export interface MonologScriptSnapshotIn extends SnapshotIn<typeof MonologScript> {}
